const $ = require('jquery')

module.exports = {
  init: () => {
    $(() => {
      $('.pagepanel-trigger > a').on('click', function (e) {
        const element = $(this)
        const pagePanelItem = element.parents('.pagepanel-item')
        const pagepanel = pagePanelItem.parents('.pagepanel')

        const isActive = pagePanelItem.hasClass('pagepanel-item--active')
        if (isActive) {
          pagePanelItem.removeClass('pagepanel-item--active')
          pagepanel.removeClass('pagepanel--open')
        } else {
          $('.pagepanel-item').removeClass('pagepanel-item--active')
          pagePanelItem.addClass('pagepanel-item--active')
          pagepanel.addClass('pagepanel--open')
        }

        return false
      })
      $('html, body').on('touchstart click', function (e) {
        if ($(e.target).closest('.pagepanel-content').length === 0) {
          $('.pagepanel-item').removeClass('pagepanel-item--active')
          $('.pagepanel').removeClass('pagepanel--open')
        }
      })
    })
  }
}
